import { SET_ONLINE_STATUS, SET_RESTAURANT_DATA, SET_WAIT_TIME } from './constants';

const initialState = {
  shop: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RESTAURANT_DATA:
      return {
        ...state,
        shop: action.payload,
      };
    case SET_ONLINE_STATUS:
      return {
        ...state,
        shop: {
          ...state.shop,
          isOnline: action.payload,
        }
      };
    case SET_WAIT_TIME:
      return {
        ...state,
        shop: {
          ...state.shop,
          waitTime: action.payload,
        }
      }
    default:
      return state;
  }
};

export default reducer;